import React from 'react'
import { PersonAddIcon } from '@/assets/icons'
import { countLabel } from '@/utils/plural'
import AvatarStack from './AvatarStack'
import { OverviewHero } from './core'
import {
	DaysPill,
	HeroAvatars,
	HeroCenter,
	HeroDates,
	HeroMeta,
	HeroTitle,
	HeroTopBar,
	HeroWrap,
	InviteChip,
} from './Hero.styles'
import { iconSizes } from '@/theme/tokens'
import { TestIds } from '@/testIds'

interface HeroProps {
	hero: OverviewHero
	/** Navigates to the members page when the avatar stack is activated. */
	onAvatarsClick?: () => void
	/** Optional control rendered top-right (e.g. member-mode Trip Settings). */
	action?: React.ReactNode
	/** When provided, an invite chip joins the avatar row. Members only — the
	 *  public overview never offers it. */
	onInviteClick?: () => void
}

/** Trip overview hero: title, days pill + dates, and a members avatar stack. */
const Hero: React.FC<HeroProps> = ({ hero, onAvatarsClick, action, onInviteClick }) => (
	<HeroWrap data-testid={TestIds.tripOverview.header}>
		<HeroTopBar>{action}</HeroTopBar>
		<HeroCenter>
			<HeroTitle data-testid={TestIds.tripOverview.tripName}>{hero.name}</HeroTitle>
			{hero.hasDates && (
				<HeroMeta>
					<DaysPill>
						{countLabel(hero.dayCount, 'day')}
					</DaysPill>
					{hero.dateRange && <HeroDates>{hero.dateRange}</HeroDates>}
				</HeroMeta>
			)}
			{(hero.memberCount > 0 || onInviteClick) && (
				<HeroAvatars>
					{hero.memberCount > 0 && (
						<AvatarStack
							travelers={hero.travelers}
							memberCount={hero.memberCount}
							size={34}
							showNames
							onClick={onAvatarsClick}
						/>
					)}
					{onInviteClick && (
						<InviteChip type="button" onClick={onInviteClick}>
							<PersonAddIcon sx={{ fontSize: iconSizes.sm }} />
							Invite
						</InviteChip>
					)}
				</HeroAvatars>
			)}
		</HeroCenter>
	</HeroWrap>
)

export default Hero
